import { isBoard, isAlias } from '../../../../common/elements/utils/elementTypeUtils';
import { sortByModified } from '../../../../common/elements/utils/elementSortUtils';
import { getElements } from '../../../element/selectors/elementsSelector';
import { elementGraphSelector } from '../../../element/selectors/elementGraphSelector';
import { getChildrenViaGraph } from '../../../../common/elements/utils/elementGraphUtils';
import { getCurrentBoardIdFromState } from '../../../reducers/currentBoardId/currentBoardIdSelector';
import { ELEMENT_MOVE, ELEMENT_UPDATE } from '../../../../common/elements/elementConstants';
import {
    ELEMENTS_DESELECT_ALL,
    ELEMENTS_DESELECTED,
    ELEMENTS_SELECTED,
} from '../../../../common/elements/selectionConstants';
import { DRAG_START } from '../../../reducers/draggingConstants';
import { MODAL_OPEN } from '../../../components/modal/modalConstants';
import { POPUP_CLOSE, POPUP_OPEN, POPUP_TOGGLE } from '../../../components/popupPanel/popupConstants';
import { USER_NAVIGATE } from '../../../../common/users/userConstants';

export const DEFAULT_DISABLE_SELECTORS = [
    '.Trash',
    '.ReferUtil',
    '.CurrentBoardHeader .BoardTitle',
    '.HeaderShareButtonUtil',
    '.BoardEditorUtil',
    '.ExportUtil',
    '.ScaleUtil',
    '.InboxClosed',
    '.ImageTool',
    '.FileTool',
    '.DrawingTool',
    '.AiAssistantTool',
    '.ToolbarPopupTool.MoreTool',
    '.UndoRedoUtil',
];

const selectMostRecent = (elementTypePredicate, fallbackSelector) => (action, state) => {
    const elements = getElements(state);
    const elementGraph = elementGraphSelector(state);
    const currentBoardId = getCurrentBoardIdFromState(state);

    const children = getChildrenViaGraph({ elements, elementGraph, parentId: currentBoardId });

    const mostRecentElement = children.filter(elementTypePredicate).sort(sortByModified).last();

    if (!mostRecentElement) return fallbackSelector;

    return `#el-${mostRecentElement.get('id') || mostRecentElement.get('_id')}`;
};

export const selectMostRecentBoard = selectMostRecent(isBoard, '.Board');
export const selectMostRecentAlias = selectMostRecent(isAlias, '.Board');

const userInitiatedActions = [
    ELEMENT_MOVE,
    ELEMENTS_SELECTED,
    ELEMENTS_DESELECTED,
    ELEMENTS_DESELECT_ALL,
    ELEMENT_UPDATE,
    DRAG_START,
    MODAL_OPEN,
    POPUP_TOGGLE,
    POPUP_OPEN,
    POPUP_CLOSE,
    USER_NAVIGATE,
];

export const isUserInitiatedAction = (action) => {
    return !action.remote && userInitiatedActions.includes(action.type);
};
